<template>
  <v-container fluid>
    <v-card flat class="mx-auto bookings" style="background: #f4f5fa">
      <v-card-text>
        <v-row>
          <v-col cols="12" md="3" lg="3">
            <v-sheet
              class="overline px-3 d-flex flex-column text-center align-items-center"
            >
              <h3 class="programme primary--text">
                {{ currentProgramme.programme || "N/A" }}
              </h3>
              <p class="programme">Programme</p>
            </v-sheet>
          </v-col>
          <v-col cols="12" md="3" lg="3">
            <v-sheet
              class="overline px-3 d-flex flex-column text-center align-items-center"
            >
              <h3 class="programme primary--text">
                {{ currentProgramme["registrationID"] || "N/A" }}
              </h3>
              <p class="programme text-uppercase">Student ID</p>
            </v-sheet>
          </v-col>
          <v-col cols="12" md="3" lg="3">
            <v-sheet
              class="overline px-3 d-flex flex-column text-center align-items-center"
            >
              <h3 class="font-weight-bold programme primary--text">
                {{ currentProgramme["intakeYear"] }},
                {{ currentProgramme["intakeSemester"] || "N/A" }}
              </h3>
              <p class="programme text-uppercase">Session</p>
            </v-sheet>
          </v-col>
          <v-col cols="12" md="3" lg="3">
            <v-sheet
              class="overline px-3 d-flex flex-column text-center align-items-center"
            >
              <h3 class="font-weight-bold programme primary--text">
                {{ currentProgramme["intakeStage"] || "N/A" }}
              </h3>
              <p class="programme text-uppercase">Stage Of Study</p>
            </v-sheet>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <!--BEGIN student units-->
    <v-card flat>
      <v-card-title>
        <p>My Bookings</p>
        <v-spacer />
        <div class="ma-2">
          <v-btn
            class="primary"
            @click="examUnitsDialogBox = true"
            :disabled="disableBook"
            >Book Units
          </v-btn>
        </div>
      </v-card-title>
      <!--BEGIN exam bookings listing-->
      <v-card-text>
        <v-data-table
          :items="studentExamRegistrations"
          :sort-by="['registrationDate']"
          :sort-desc="[true]"
          class="bookings"
          hide-default-footer
          :headers="headers"
        >
          <template v-slot:[`item.ID`]="{ index }">
            <span>{{ index + 1 }}</span>
          </template>
          <template v-slot:[`item.programme`]="{ item }">
            <span>{{ item["programme"] }}, {{ item["intakeStage"] }}</span>
          </template>
          <template v-slot:[`item.session`]="{ item }">
            <span>{{ item["intakeYear"] }}, {{ item["intakeSemester"] }}</span>
          </template>
          <template v-slot:[`item.invoiced`]="{ item }">
            <span
              ><v-icon
                size="12"
                :color="
                  item.invoiced ? 'green darken-1' : 'deep-orange darken-1'
                "
                >mdi-radiobox-marked</v-icon
              >
              {{ item.invoiced ? "Confirmed" : "Pending" }}</span
            >
          </template>
          <template v-slot:[`item.status`]="{ item }">
            <span
              ><v-icon size="12" :color="statusColor[item.status]"
                >mdi-radiobox-marked</v-icon
              >
              {{ item["status"] }}</span
            >
          </template>
          <template v-slot:[`item.totalAmount`]="{ item }">
            <span>{{ item["totalAmount"] | currencyFormat }}</span>
          </template>
          <!--BEGIN board actions-->
          <template v-slot:[`item.action`]="{ item }">
            <v-menu open-on-hover>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  class="text-capitalize links"
                  text
                  v-bind="attrs"
                  v-on="on"
                  small
                  ><v-icon>mdi-dots-vertical</v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item
                  v-if="studentExamRegistrations[0].totalTakenUnits !== 0"
                  :to="{
                    name: 'ExamBookingList',
                    params: { code: encryptedViewParam(item) },
                  }"
                >
                  <span class="table-exam">
                    <v-icon color="primary" size="20" class="mr-1">
                      mdi-eye
                    </v-icon>
                    View
                  </span>
                </v-list-item>
                <v-list-item
                  v-if="
                    studentExamRegistrations[0].totalTakenUnits === 0 ||
                    disableBook
                  "
                  @click="examUnitsDialogBox = true"
                >
                  <span class="table-exam primary--text"> Book Units </span>
                </v-list-item>
              </v-list>
            </v-menu>
          </template>
          <template v-slot:[`body.append`]>
            <a
              href="https://kiseb.or.ke/sites/default/files/KISEB/docs/Exam%20Booking%20Procedure.pdf"
              class="primary--text"
              target="_blank"
            >
              <span class="font-weight-light font1 mr-3">
                Need help booking an exam?
              </span>
            </a>
          </template>
          <!--END board actions-->
        </v-data-table>
      </v-card-text>
      <!--END exam bookings listing-->
    </v-card>
    <ExamUnitsDialog
      :examUnitsDialogBox="examUnitsDialogBox"
      @setExamUnitsModal="setExamUnitsModal"
      @proceedToBookingList="proceedToBookingList"
    />
    <!--END student units-->
  </v-container>
</template>

<script>
import ExamUnitsDialog from "@/packages/exams/components/examUnitsDialog";
import { mdiCurrencyUsd } from "@mdi/js";
import examMixins from "@/packages/exams/examMixins";
import status from "@/packages/applications/status";
import { helper } from "@/packages/dashboard/utils";
import { AuthService } from "@/packages/dashboard/modules/auth";
export default {
  name: "examBookingCard",
  mixins: [examMixins],
  components: {
    ExamUnitsDialog,
  },
  data: () => ({
    examUnitsDialogBox: false,
    usdSymbol: mdiCurrencyUsd,
    selected: true,
    selectedTransactionID: "",
    headers: [
      { text: "#S/N", value: "ID" },
      { text: "Registration Date", value: "registrationDate" },
      { text: "Programme", value: "programme" },
      { text: "Session", value: "session" },
      { text: "Booked Units", value: "totalTakenUnits" },
      { text: "Total Amount", value: "totalAmount" },
      { text: "Payment Status", value: "invoiced" },
      { text: "Status", value: "status" },
      { text: "Actions", value: "action" },
    ],
  }),
  computed: {
    // this value returns the student exam registration history
    studentExamRegistrations() {
      return this.$store.getters["Exam/studentExamGetter"](
        "studentRegistrations",
      );
    },
    intakePeriods() {
      return this.$store.getters["Dashboard/intakePeriods"]
        .filter((el) => el.current)
        .shift();
    },
    disableBook() {
      return this.intakePeriods
        ? new Date(this.intakePeriods.bookingDueDate).getDate() ===
            new Date().getDate()
        : true;
    },
    currentProgramme() {
      return this.$store.getters["Exam/studentExamGetter"](
        "programmeRegistration",
      );
    },
    statusColor() {
      return status;
    },
    student() {
      return AuthService.user;
    },
  },
  methods: {
    setExamUnitsModal: function (value) {
      this.examUnitsDialogBox = value;
    },
    encryptedPaymentParam(item) {
      return helper.encrypt(item["transactionID"]);
    },
    encryptedViewParam(item) {
      return helper.encrypt(item["transactionID"]);
    },
    proceedToBookingList(value) {
      this.$router.push({
        name: "ExamBookingList",
        params: { code: helper.encrypt(value) },
      });
    },
  },
};
</script>

<style>
.theme--light.v-data-table tbody tr:nth-of-type(odd) {
  background-color: #f4fafa;
}
.theme--light.v-data-table tbody tr:nth-of-type(even) {
  background-color: #f4f5fa;
}
.theme--dark.v-data-table tbody tr:nth-of-type(odd) {
  background-color: rgba(0, 0, 0, 0.5);
}
</style>
